

const DataLayer = window.dataLayer || [];
  


export default DataLayer
